export default {
  name: 'appBackground',
  inject: [
    '$utils'
  ],
  components: {
  },
  props: {
    data: {
      default () { return 'object' }
    }
  },
  watch: {
    '$route' (routeTo) {
      this.handleBackground(routeTo.name)
    }
  },
  mixins: [],
  data () {
    return {
      gradienBackgroundVisible: false,
      specialEventBackground: false,
      enableSpecialEventBackground: false,
      isSignInPage: false,
      isLicensesTheme: false,
      devBackground: false,
      specialEventBackgroundVideo: null,
      specialEventVideoLink: null
    }
  },
  methods: {
    handleBackground (pageName) {
      if (this.$utils.isPageForLicenses()) {
        this.gradienBackgroundVisible = false
        this.isLicensesTheme = true
        this.isSignInPage = false
        return
      }

      switch (pageName) {
        case 'page-not-found':
          this.gradienBackgroundVisible = true
          this.specialEventBackground = false
          this.isLicensesTheme = false
          this.isSignInPage = false
          this.specialEventBackground = false
          this.specialEventBackground = false
          break
        case 'signIn':
          this.isSignInPage = true
          this.gradienBackgroundVisible = false
          this.specialEventBackground = true
          this.isLicensesTheme = false
          $('.show-animate-clouds').removeClass('ready')

          // Events if special event background enabled
          if (this.enableSpecialEventBackground && this.specialEventBackground) {
            this.$nextTick(_ => {
              window.setTimeout(() => {
                this.specialEventBackgroundVideo = this.$refs.specialEventBackgroundVideo
                this.specialEventBackgroundVideo.addEventListener('loadeddata', () => {
                  $('.show-animate-clouds').addClass('ready')
                })
                this.specialEventBackgroundVideo.addEventListener('play', () => {
                })

                this.specialEventBackgroundVideo.addEventListener('ended', () => {
                  this.specialEventBackground = false
                  $('.sign-in-right-column').removeClass('hide-for-special-event')
                  $('.show-animate-clouds').addClass('animate')
                })
              }, 2)
            })
          }

          break
        case 'distributor':
          this.isSignInPage = true
          this.gradienBackgroundVisible = false
          this.specialEventBackground = false
          this.isLicensesTheme = true
          break
        case 'activation':
          this.isSignInPage = true
          this.gradienBackgroundVisible = false
          this.specialEventBackground = false
          this.isLicensesTheme = true
          break
        default:
          this.gradienBackgroundVisible = false
          this.specialEventBackground = false
          this.isSignInPage = false
          this.isLicensesTheme = false

          // Set development background
          if (localStorage.getItem('aryaDevBackground')) {
            const aryaDevBackground = JSON.parse(localStorage.getItem('aryaDevBackground'))
            if (aryaDevBackground.on) {
              let backgroundUrl = aryaDevBackground.background ? aryaDevBackground.background[0] : []

              if (aryaDevBackground.sourceIndx) {
                backgroundUrl = aryaDevBackground.background[aryaDevBackground.sourceIndx]
              }

              let appBackgroundStyle = { background: `url(${backgroundUrl}) no-repeat` }

              if (aryaDevBackground.backgroundColor) {
                appBackgroundStyle = { background: 'unset', backgroundColor: aryaDevBackground.backgroundColor }
              }

              $('#appBackground').css(appBackgroundStyle)
            }
          }
      }
    }
  },
  mounted () {
    this.handleBackground(this.$route.name)
  }
}
